import * as React from 'react';
import { observer } from 'mobx-react-lite';
import FullComposeEditorAreaBottom from './FullComposeEditorAreaBottom';
import { showStickyDockingCover, showDockedBottom } from 'owa-editor-docking-plugin';
import { getFullComposeViewState } from 'owa-calendar-compose-store-manager';

const styles = require('./FullComposeLeftPane.scss');
export interface FullComposeDockedBottomProps {
    formId: string | null;
}

const FullComposeDockedBottom: React.FunctionComponent<FullComposeDockedBottomProps> = props => {
    const { formId } = props;
    const { docking } = getFullComposeViewState(formId);

    return (
        <>
            <div
                className={showStickyDockingCover(docking) ? styles.useStickyDockingCover : null}
                style={{
                    bottom: docking.scrollBarHeight + docking.bottomDockingBottom,
                    width: docking.dockingWidth + 2,
                }}
            />
            {showDockedBottom(docking) && (
                <div
                    className={styles.dockingContainer}
                    style={{ bottom: docking.scrollBarHeight + docking.bottomDockingBottom }}>
                    <div className={styles.bottomContainer} style={{ width: docking.dockingWidth }}>
                        <FullComposeEditorAreaBottom formId={formId} />
                    </div>
                    <div className={styles.absoluteDockingCover} />
                </div>
            )}
        </>
    );
};

export default observer(FullComposeDockedBottom);
